import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock, ArrowLeft } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-secondary/60 border border-border focus:border-primary outline-none px-4 h-12 font-mono-tech text-sm transition-colors";

  return (
    <div className="min-h-screen grid place-items-center bg-background blueprint-grid px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <Link to="/" className="inline-flex items-center gap-2 font-mono-tech text-[11px] tracking-widest uppercase text-muted-foreground hover:text-primary mb-8">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <Lock size={20} className="text-primary" />
          <span className="font-mono-tech text-xs tracking-widest uppercase text-muted-foreground">Lead Dashboard</span>
        </div>
        <h1 className="font-display uppercase tracking-tight text-3xl mb-6">Admin Login</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password" />
          {error && <p className="text-sm text-destructive font-mono-tech" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-primary text-primary-foreground font-mono-tech text-xs tracking-widest uppercase h-12 hover:bg-[hsl(16,100%,55%)] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
